/**
 * La forme d'une étape à choix de « Compléter mon profil », le temps que le compte arrive (les
 * réponses déjà données pré-remplissent les étapes) : la phrase d'aide, puis deux pilules.
 */
import React from "react"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"

export function TutorCompleteProfileSkeleton() {
    return (
        <Stack gap="4">
            <Skeleton textSize="text-lg" width={260} />
            <Row gap="2">
                <Skeleton shape="block" width={72} height={pushButtonBoxHeight("sm")} />
                <Skeleton shape="block" width={72} height={pushButtonBoxHeight("sm")} />
            </Row>
        </Stack>
    )
}
